<template>
  <div>
    <b-modal
      id="intergrationsModal"
      ref="intergrationsModal"
      :no-close-on-backdrop="true"
      cancel-variant="outline-secondary"
      :ok-title="$t('DEBTIA_COMMON_CONFIRM')"
      :title="$t('DEBTIA_CONFIRM')"
      footer-class="d-flex justify-content-center"
      @ok="redirectLink()"
    >
      <b-overlay
        id="overlay-background"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <div>
          <div class="flex justify-center items-center">
            <p class="text-center">
              {{ $t('DEBTIA_CONFIRMATION_NOTE') }}
            </p>
          </div>
        </div>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BOverlay, BModal,
} from 'bootstrap-vue'

export default {
  components: {
    BOverlay,
    BModal,
  },
  props: {
    redirectLink: {
      type: Function,
      required: true,
    },
  },
  methods: {
    open() {
      this.$refs.intergrationsModal.show()
    },
  },
}
</script>
